export default __webpack_public_path__ + "static/media/icon_paint_pad_vector.466eb03b.svg";